export default {
  cancelText: '取消',
  okText: '确定',
  title: '请选择'
};